import { useRouteError, Link } from "react-router-dom";
import { ReactComponent as Logo } from '../images/logo_header.svg';
import './games/GameView.css';

export default function ErrorPage() {

  const error = useRouteError();
  console.error(error);

  return (
    <div className="darkPage">
      <div className="topBar">
        <Link to="/"><Logo className="logo" /></Link>
      </div>
      <div className="page" style={{ paddingTop: 40 }}>
        <div className="gcard center">
          <div className="bold" style={{ fontSize: 18 }}>Whoops, we missed that one</div>
          <div className="muted" style={{ marginTop: 8, lineHeight: 1.5 }}>
            This page had an error, which is kind of like a three putt.
          </div>
          <div style={{ marginTop: 18 }}>
            <a className="btnGhost" href="https://puttr.co">Go to puttr.co</a>
          </div>
        </div>
      </div>
    </div>
  );
}
